import {
  AppBar,
  Box,
  Button,
  Container,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Link as RouterLink, useLocation } from "react-router";

const NAVY = "#102B63";
const CTA_ORANGE = "#F5A623";

const navItems = [
  { label: "À propos", to: "/a-propos" },
  { label: "Qui sommes-nous", to: "/qui-sommes-nous" },
  { label: "Nos services", to: "/services" },
  { label: "Nos produits", to: "/produits" },
];

export default function Header() {
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "rgba(244,247,252,0.86)",
        backdropFilter: "blur(16px)",
        borderBottom: `1px solid ${alpha(NAVY, 0.08)}`,
        color: NAVY,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          sx={{
            minHeight: 82,
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.4,
              px: 1.3,
              py: 0.8,
              borderRadius: "20px",
              background:
                "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,245,253,0.9) 100%)",
              border: `1px solid ${alpha(NAVY, 0.08)}`,
              boxShadow: "0 10px 26px rgba(16,43,99,0.08)",
              textDecoration: "none",
            }}
          >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/assets/axiontek-logo.png`}
              alt="Axiontek"
              sx={{
                width: { xs: 56, md: 68 },
                height: { xs: 56, md: 68 },
                objectFit: "contain",
                display: "block",
              }}
            />

            <Box>
              <Typography
                sx={{
                  fontSize: { xs: 16, md: 18 },
                  fontWeight: 900,
                  lineHeight: 1,
                  letterSpacing: "0.04em",
                  color: NAVY,
                }}
              >
                AXIONTEK
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: 10.5, md: 12 },
                  fontWeight: 700,
                  color: "#4B618B",
                  lineHeight: 1.1,
                  letterSpacing: "0.08em",
                }}
              >
                SCALE WITH CONFIDENCE
              </Typography>
            </Box>
          </Box>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            {navItems.map((item) => {
              const active = isActive(item.to);

              return (
                <Button
                  key={item.label}
                  component={RouterLink}
                  to={item.to}
                  sx={{
                    position: "relative",
                    color: active ? NAVY : alpha(NAVY, 0.9),
                    fontWeight: active ? 900 : 800,
                    px: 1.8,
                    py: 1,
                    borderRadius: "999px",
                    backgroundColor: active
                      ? alpha(NAVY, 0.08)
                      : "transparent",
                    border: active
                      ? `1px solid ${alpha(NAVY, 0.12)}`
                      : "1px solid transparent",
                    "&:hover": {
                      backgroundColor: active
                        ? alpha(NAVY, 0.1)
                        : alpha(NAVY, 0.05),
                    },
                    "&::after": active
                      ? {
                          content: '""',
                          position: "absolute",
                          left: "50%",
                          bottom: 6,
                          transform: "translateX(-50%)",
                          width: 18,
                          height: 3,
                          borderRadius: 999,
                          backgroundColor: CTA_ORANGE,
                        }
                      : {},
                  }}
                >
                  {item.label}
                </Button>
              );
            })}

            <Button
              href="https://www.linkedin.com/company/axiontek/"
              target="_blank"
              rel="noreferrer"
              variant="contained"
              sx={{
                ml: 1,
                color: NAVY,
                fontWeight: 900,
                borderRadius: "999px",
                backgroundColor: CTA_ORANGE,
                boxShadow: "0 14px 26px rgba(245,166,35,0.22)",
                "&:hover": {
                  backgroundColor: "#E79C1F",
                },
              }}
            >
              LinkedIn
            </Button>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
}